<template>
  <div>
    <v-menu>
      <template #activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- User Info -->
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2" />

        <v-list-item @click="$emit('open-workspace-search')">
          <v-list-item-icon>
            <v-icon>mdi-form-select</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Changer de workspace</v-list-item-title>
        </v-list-item>

        <!-- Action Items -->
        <template v-if="![$store.state.centralizedWorkspace, 'spontaneous'].includes(activeWorkspace)">
          <v-list-item :disabled="!canPerformAction('CREATE_PROSPECT')" :to="{ name: 'add-candidate' }">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Créer un candidat</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="!canPerformAction('VIEW_PROSPECT')" :to="{ name: 'candidates-list'}">
            <v-list-item-icon>
              <v-icon>mdi-folder-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Liste des candidats</v-list-item-title>
          </v-list-item>
        </template>

        <v-divider class="my-2" />

        <!-- Logout -->
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { getLogoutUrl } from '@/utils/auth';

export default {
  name: 'MobileHeaderActions',
  props: {
    user: {
      type: Object,
      required: true
    },
    activeWorkspace: {
      type: String,
      required: true
    },
    canPerformAction: {
      type: Function,
      required: true
    }
  },
  methods: {
    logout () {
      ['sessionStorage'].map(storage => window[storage].clear());

      window.location.href = getLogoutUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID, window.location.origin);
    }
  }
};
</script>
